// extracted by mini-css-extract-plugin
export default {"nav_menu":"NavMenu_nav_menu__hk3ac"};